import { css, keyframes } from '@emotion/css';
import * as Dialog from '@radix-ui/react-dialog';
import { BackDrop, uiConfig } from '@volumental/common';
import React, { type JSX } from 'react';

const fadeIn = keyframes`
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
`;
const container = (show: boolean): string => css`
  position: fixed;
  inset: 0;
  z-index: 2;
  animation: ${show ? fadeIn : fadeOut} 0.3s ease-out;
`;
const modal = (fixAspect: boolean): string => css`
  font-family: ${uiConfig.styles.fontFamily};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: white;
  border-radius: 25px;
  max-height: calc(100% - 34px);
  padding-top: 24px;
  outline: none;
  z-index: 3;
  overflow: hidden;
  object-fit: contain;
  animation: ${fadeIn} 0.3s ease-out;

  ${fixAspect
    ? css`
        aspect-ratio: 1;
        width: 80%;
        max-width: 300px;
      `
    : css`
        max-width: 90%;
      `}
`;

export interface PopupProps {
  show: boolean;
  fixAspect?: boolean;
  close?: () => void;
  children: React.ReactNode;
}

export function Popup({
  show,
  fixAspect = false,
  close,
  children,
}: PopupProps): JSX.Element {
  return (
    <Dialog.Root open={show} onOpenChange={(open) => !open && close?.()}>
      <Dialog.Portal>
        <div className={container(show)}>
          <BackDrop visible={show} animationTime="0.3s" onClick={close} />
          <Dialog.Content
            onEscapeKeyDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              close?.();
            }}
            className={modal(fixAspect)}
          >
            {children}
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
